/**
 * LocationDisclaimer - Small print disclaimer for menu pricing and promotions
 * Used across menu, order, and other relevant pages
 */
export default function LocationDisclaimer({ className = "" }) {
  return (
    <p className={`text-xs text-muted-foreground/70 text-center ${className}`}>
      All promotions and menu pricing are exclusive to Bulaccino Cafe located at Shop 3 at Concave Road, Namaka, Nadi, Fiji and not any other location.
    </p>
  );
}
